import { Loader2, PlugZap } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Panel } from "./fields";
import { KeyField, SaveButton, useIntegrationForm } from "./integrationForm";

const KEYS = ["HOLD_MINUTES", "STAFF_ALERT_EMAILS", "REMINDER_DAYS"];

const Info = ({ label, value, testid }) => (
  <div><p className="field-label">{label}</p><p className="mt-1 font-mono text-sm" data-testid={testid}>{value || "—"}</p></div>
);

export const ReservationTab = () => {
  const { data, form, set, save, busy } = useIntegrationForm(KEYS);
  const [testing, setTesting] = useState(false);
  if (!form) return <Loader2 className="h-6 w-6 animate-spin text-brand" />;
  const test = async () => {
    setTesting(true);
    try {
      const { data: r } = await api.post("/admin/connection/test");
      toast.success(`Connected: ${r.hotels} hotel(s), ${r.rooms} room type(s)`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setTesting(false);
    }
  };
  const s = data.site;
  const p = { form, set };
  return (
    <div className="space-y-6" data-testid="admin-reservation-tab">
      <Panel title="eRes reservation system" hint="Set up by the platform administrator. Contact them to change the eRes database or properties.">
        <div className="grid gap-5 md:grid-cols-3">
          <Info label="Data source" value={s.provider === "eres" ? "Live eRes" : "Demo data (no real bookings)"} testid="eres-provider-info" />
          <Info label="eRes database" value={s.eres_db} testid="eres-db-info" />
          <Info label="Property codes" value={s.hotel_codes.join(", ")} testid="eres-codes-info" />
        </div>
        <button type="button" className="btn-outline mt-5" onClick={test} disabled={testing} data-testid="eres-test">
          {testing ? <Loader2 className="h-4 w-4 animate-spin" /> : <PlugZap className="h-4 w-4" />}Test connection
        </button>
      </Panel>
      <Panel title="Holds, alerts and reminders">
        <div className="grid gap-5 md:grid-cols-2">
          <KeyField label="Release unpaid holds after (minutes, 5-240)" name="HOLD_MINUTES" {...p} testid="hold-minutes" />
          <KeyField label="Reservations team alert emails (comma separated)" name="STAFF_ALERT_EMAILS" {...p} testid="staff-alert-emails" />
          <KeyField label="Send balance reminder (days before due date)" name="REMINDER_DAYS" {...p} testid="reminder-days" />
        </div>
        <div className="mt-5"><SaveButton busy={busy} onClick={() => save()} testid="eres-save" /></div>
      </Panel>
    </div>
  );
};
